export enum TimeType {
  DAYS = 0,
  MONTHS,
  YEARS
}

export enum TimeTypeEn {
  DAYS = 'Days',
  MONTHS = 'Months',
  YEARS = 'Years'
}

export enum TimeTypeEs {
  DAYS = 'Días',
  MONTHS = 'Meses',
  YEARS = 'Años'
}

export enum TimeTypePt {
  DAYS = 'Dias',
  MONTHS = 'Meses',
  YEARS = 'Anos'
}

export enum DurationType {
  FIFTEEN = 15,
  THIRTY = 30,
  ONE_HOUR = 60,
  TWO_HOURS = 120
}

export enum DurationEn {
  FIFTEEN = '15 minutes',
  THIRTY = '30 minutes',
  ONE_HOUR = '1 hour',
  TWO_HOURS = '2 hours'
}

export enum PeriodEn {
  PERSONALIZED = 'Personalized',
  ALL_DAY = 'All Day',
  THIS_WEEK = 'This Week',
  THIS_MONTH = 'This Month'
}

export enum DurationEs {
  FIFTEEN = '15 minutos',
  THIRTY = '30 minutos',
  ONE_HOUR = '1 hora',
  TWO_HOURS = '2 horas'
}

export enum PeriodEs {
  PERSONALIZED = 'Personalizado',
  ALL_DAY = 'Todo el día',
  THIS_WEEK = 'Esta semana',
  THIS_MONTH = 'Este mes'
}

export enum DurationPt {
  FIFTEEN = '15 minutos',
  THIRTY = '30 minutos',
  ONE_HOUR = '1 hora',
  TWO_HOURS = '2 horas'
}

export enum PeriodPt {
  PERSONALIZED = 'Personalizado',
  ALL_DAY = 'Dia inteiro',
  THIS_WEEK = 'Esta semana',
  THIS_MONTH = 'Este mês'
}

export enum IsAvailableEn {
  YES = 'Yes',
  NO = 'No'
}

export enum IsAvailableEs {
  YES = 'Sí',
  NO = 'No'
}

export enum IsAvailablePt {
  YES = 'Sim',
  NO = 'Não'
}

export enum DurationTypeEn {
  UNLIMITED = 'Unlimited',
  LIMITED = 'Limited'
}

export enum DurationTypeEs {
  UNLIMITED = 'Ilimitado',
  LIMITED = 'Limitado'
}

export enum DurationTypePt {
  UNLIMITED = 'Ilimitado',
  LIMITED = 'Limitado'
}

export const durationOptionsEn = [DurationEn.FIFTEEN, DurationEn.THIRTY, DurationEn.ONE_HOUR, DurationEn.TWO_HOURS];
export const durationOptionsEs = [DurationEs.FIFTEEN, DurationEs.THIRTY, DurationEs.ONE_HOUR, DurationEs.TWO_HOURS];
export const durationOptionsPt = [DurationPt.FIFTEEN, DurationPt.THIRTY, DurationPt.ONE_HOUR, DurationPt.TWO_HOURS];
export const periodOptionsEn = [PeriodEn.PERSONALIZED, PeriodEn.ALL_DAY, PeriodEn.THIS_WEEK, PeriodEn.THIS_MONTH];
export const periodOptionsEs = [PeriodEs.PERSONALIZED, PeriodEs.ALL_DAY, PeriodEs.THIS_WEEK, PeriodEs.THIS_MONTH];
export const periodOptionsPt = [PeriodPt.PERSONALIZED, PeriodPt.ALL_DAY, PeriodPt.THIS_WEEK, PeriodPt.THIS_MONTH];
export const isAvailableOptionsEn = [IsAvailableEn.YES, IsAvailableEn.NO];
export const isAvailableOptionsEs = [IsAvailableEs.YES, IsAvailableEs.NO];
export const isAvailableOptionsPt = [IsAvailablePt.YES, IsAvailablePt.NO];
export const durationTypeOptionsEn = [DurationTypeEn.UNLIMITED, DurationTypeEn.LIMITED];
export const durationTypeOptionsEs = [DurationTypeEs.UNLIMITED, DurationTypeEs.LIMITED];
export const durationTypeOptionsPt = [DurationTypePt.UNLIMITED, DurationTypePt.LIMITED];
export const timeTypeOptionsEn = [TimeTypeEn.DAYS, TimeTypeEn.MONTHS, TimeTypeEn.YEARS];
export const timeTypeOptionsEs = [TimeTypeEs.DAYS, TimeTypeEs.MONTHS, TimeTypeEs.YEARS];
export const timeTypeOptionsPt = [TimeTypePt.DAYS, TimeTypePt.MONTHS, TimeTypePt.YEARS];